import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const PresentPlayFilledIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M12.667 1.5C13.6793 1.50018 14.4998 2.32074 14.5 3.33301V12.667C14.4998 13.6793 13.6793 14.4998 12.667 14.5H3.33301C2.32074 14.4998 1.50018 13.6793 1.5 12.667V3.33301C1.50018 2.32074 2.32074 1.50018 3.33301 1.5H12.667ZM6.25 4.53613C5.91667 4.34373 5.5 4.58485 5.5 4.96973V11.0312C5.5 11.4161 5.9167 11.6571 6.25 11.4648L11.5 8.43359C11.8333 8.24115 11.8333 7.75984 11.5 7.56738L6.25 4.53613Z"
      fill="currentColor"
    />
  </svg>
);
